import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import urlTemplate from 'url-template';
import { errorIfNotOk, stargateFetch } from '../fetch-utils';
var hisiGetFlagTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/{cloudId}/hisi/flag{?userKey,flagKey}');
export var hisiSetFlagUrl = '/engage-targeting/api/v2/user/{cloudId}/hisi/flag';
export function getFlag(_x, _x2, _x3, _x4) {
  return _getFlag.apply(this, arguments);
}
function _getFlag() {
  _getFlag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stargateUrl, cloudId, flagKey, userKey) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", stargateFetch("".concat(stargateUrl).concat(hisiGetFlagTemplate.expand({
            cloudId: cloudId,
            userKey: userKey,
            flagKey: flagKey
          })), {
            method: 'GET'
          }).then(errorIfNotOk).then(function (r) {
            return r.json();
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getFlag.apply(this, arguments);
}
export function setFlag(_x5, _x6, _x7, _x8) {
  return _setFlag.apply(this, arguments);
}
function _setFlag() {
  _setFlag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stargateUrl, cloudId, flagKey, userKey) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", stargateFetch("".concat(stargateUrl).concat(hisiSetFlagUrl), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              userKey: userKey,
              flagKey: flagKey
            })
          }).then(errorIfNotOk).then(function (r) {
            return r;
          }).then(function () {
            return Promise.resolve();
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _setFlag.apply(this, arguments);
}